module.exports = __webpack_public_path__ + "img/diploma.26c129fa.png";